import React from 'react'
import Page from './components/page/page';
import { isMobile } from './util';
import Dialog from './components/page/dialog';

class App extends React.Component
{

    constructor(props)
    {
        super(props)
        this._isRotateDialogShown = false
    }

    manageRotateDialog()
    {
        if (typeof window.getDialog !== "function")
        {
            return;
        }
        if (document.body.clientWidth < document.body.clientHeight)
        {
            getDialog().show({ content: Messages("app.rotate-device") })
            this._isRotateDialogShown = true
        } 
        else if (this._isRotateDialogShown)
        {
            this._isRotateDialogShown = false
            getDialog().dismiss()
        }
    }

    componentDidMount()
    {
        this.manageRotateDialog()
        window.addEventListener("resize", () => {
            this.forceUpdate()
            this.manageRotateDialog()
        })
        window._forceUpdateRootComponent = () => this.forceUpdate()
    }

    render()
    {
        return (
            <div className={ "frame " + (isMobile() ? " mobile" : "") }>
                <Page />
                <Dialog create={ dialog => {
                    window.getDialog = () => dialog
                    this.manageRotateDialog()
                } } />
            </div>
        )
    }

}

export default App
export { App }